import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SecurityNoticeDialogComponent } from 'app/modules/shared/containers/security-notice-dialog/security-notice-dialog.component';

/** localStorage flag: the notice has been confirmed in this browser. Not user data, it survives sign-out. */
export const SECURITY_NOTICE_KEY = 'securityNoticeSeen';

/**
 * Shows the security notes (device protection, BSI TR-03161-2 O.Plat_1, and data remaining in the device's memory,
 * O.Plat_7) once per browser, after the user has signed in. The dialog stays open until the user confirms it, so it
 * cannot be overlooked. The memory advice is also always at hand next to "Sign out" in the user menu.
 */
@Injectable({ providedIn: 'root' })
export class SecurityNoticeService {
    private _dialog = inject(MatDialog);
    private _open = false;

    showOnce(): void {
        if (this._open || this._seen()) {
            return;
        }
        this._open = true;
        this._dialog
            .open(SecurityNoticeDialogComponent, {
                width: '560px',
                maxWidth: '95vw',
                disableClose: true,
                autoFocus: false,
            })
            .afterClosed()
            .subscribe(() => {
                this._open = false;
                this._markSeen();
            });
    }

    private _seen(): boolean {
        try {
            return localStorage.getItem(SECURITY_NOTICE_KEY) === 'true';
        } catch {
            return false; // storage unavailable: the notice is simply shown again
        }
    }

    private _markSeen(): void {
        try {
            localStorage.setItem(SECURITY_NOTICE_KEY, 'true');
        } catch {
            // storage unavailable
        }
    }
}
